import React from 'react';

const PartnerIntegration = () => {
    return <div />;
};

export default PartnerIntegration;
